<core-generic-table
    [dataInput]="contact()"
    [endpoint]="endpoint()"
    [customParams]="customParams()"
    [listTitle]="'contact.title' | translate"
    [columns]="columns"
    [modalTabs]="modalFieldsTabs()"
    [actions]="actions"
    [globalActions]="globalCustomActions()"
    [dataInput]="contactsData()"
    [modelFactory]="contactsModelFactory"
    [showFilter]="false"
    [showSelection]="false"
    [showActions]="true"
    [showCreateButton]="true"
    [enablePagination]="true"
    [createButtonConfig]="createButtonConfig()">
</core-generic-table>